<template>
  <div style="background-color: #edf4fc;overflow: hidden;">
    <div style="overflow: hidden;">
      <div style="width: 72%;float: left;">
        <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin: 0.1rem;">
          <el-row :gutter="20" style="border-bottom: 1px dashed rgb(223, 221, 221);">
            <el-col :span="12">
              <div>
                <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据学校名称搜索资讯：</div>
                <div class="content-input">
                  <el-input v-model="schoolName" placeholder="请输入学校名称" class="content-input-el" clearable @keyup.enter.native="schoolFind()"></el-input>
                  <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="schoolFind()">搜索</el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="border-left: 1px dashed rgb(223, 221, 221);">
              <div style="margin-left: -0.05rem;">
                <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据资讯名称搜索资讯：</div>
                <div class="content-input">
                  <el-input v-model="dataName" placeholder="请输入资讯名称" class="content-input-el" clearable @keyup.enter.native="dataFind()"></el-input>
                  <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="dataFind()">搜索</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <div>
            <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据查询条件搜索资讯：</div>
            <div class="content-table">
              <div class="content-table-1">
                <div class="content-table-11">院校所在地：</div>
                <div class="content-table-12">
                  <el-radio-group v-model="idProvince" @change="changeSelect">
                    <el-radio label="全部" style="margin-right: 0.13rem; margin-bottom: 0.1rem">全部</el-radio>
                    <el-radio label="北京" style="margin-right: 0.13rem; margin-bottom: 0.1rem">北京</el-radio>
                    <el-radio label="天津" style="margin-right: 0.13rem; margin-bottom: 0.1rem">天津</el-radio>
                    <el-radio label="河北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河北</el-radio>
                    <el-radio label="山西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山西</el-radio>
                    <el-radio label="内蒙古" style="margin-right: 0.13rem; margin-bottom: 0.1rem">内蒙古</el-radio>
                    <el-radio label="辽宁" style="margin-right: 0.13rem; margin-bottom: 0.1rem">辽宁</el-radio>
                    <el-radio label="吉林" style="margin-right: 0.13rem; margin-bottom: 0.1rem">吉林</el-radio>
                    <el-radio label="黑龙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">黑龙江</el-radio>
                    <el-radio label="上海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">上海</el-radio>
                    <el-radio label="江苏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江苏</el-radio>
                    <el-radio label="浙江" style="margin-right: 0.13rem; margin-bottom: 0.1rem">浙江</el-radio>
                    <el-radio label="安徽" style="margin-right: 0.13rem; margin-bottom: 0.1rem">安徽</el-radio>
                    <el-radio label="福建" style="margin-right: 0.13rem; margin-bottom: 0.1rem">福建</el-radio>
                    <el-radio label="江西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">江西</el-radio>
                    <el-radio label="山东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">山东</el-radio>
                    <el-radio label="河南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">河南</el-radio>
                    <el-radio label="湖北" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖北</el-radio>
                    <el-radio label="湖南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">湖南</el-radio>
                    <el-radio label="广东" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广东</el-radio>
                    <el-radio label="广西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">广西</el-radio>
                    <el-radio label="海南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">海南</el-radio>
                    <el-radio label="重庆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">重庆</el-radio>
                    <el-radio label="四川" style="margin-right: 0.13rem; margin-bottom: 0.1rem">四川</el-radio>
                    <el-radio label="贵州" style="margin-right: 0.13rem; margin-bottom: 0.1rem">贵州</el-radio>
                    <el-radio label="云南" style="margin-right: 0.13rem; margin-bottom: 0.1rem">云南</el-radio>
                    <el-radio label="西藏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">西藏</el-radio>
                    <el-radio label="陕西" style="margin-right: 0.13rem; margin-bottom: 0.1rem">陕西</el-radio>
                    <el-radio label="甘肃" style="margin-right: 0.13rem; margin-bottom: 0.1rem">甘肃</el-radio>
                    <el-radio label="青海" style="margin-right: 0.13rem; margin-bottom: 0.1rem">青海</el-radio>
                    <el-radio label="宁夏" style="margin-right: 0.13rem; margin-bottom: 0.1rem">宁夏</el-radio>
                    <el-radio label="新疆" style="margin-right: 0.13rem; margin-bottom: 0.1rem">新疆</el-radio>
                    <el-radio label="香港" style="margin-right: 0.13rem; margin-bottom: 0.1rem">香港</el-radio>
                    <el-radio label="澳门" style="margin-right: 0.13rem; margin-bottom: 0.1rem">澳门</el-radio>
                    <el-radio label="台湾" style="margin-right: 0.13rem; margin-bottom: 0.1rem">台湾</el-radio>
                    <el-radio label="其他" style="margin-right: 0.13rem; margin-bottom: 0.1rem">其他</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="content-table-2">
                <div class="content-table-21">报考专业：</div>
                <div class="content-table-22">
                  <el-radio-group v-model="idMajor" @change="changeSelect">
                    <el-radio label="全部" style="margin-right: 0.13rem">全部</el-radio>
                    <el-radio label="MBA" style="margin-right: 0.13rem">MBA</el-radio>
                    <el-radio label="MEM-125601" style="margin-right: 0.13rem">MEM-125601</el-radio>
                    <el-radio label="MEM-125602" style="margin-right: 0.13rem">MEM-125602</el-radio>
                    <el-radio label="MPA" style="margin-right: 0.13rem">MPA</el-radio>
                    <el-radio label="MTA" style="margin-right: 0.13rem">MTA</el-radio>
                    <el-radio label="EMBA" style="margin-right: 0.13rem">EMBA</el-radio>
                    <el-radio label="MPAcc" style="margin-right: 0.13rem">MPAcc</el-radio>
                    <el-radio label="MAud" style="margin-right: 0.13rem">MAud</el-radio>
                    <el-radio label="MEM-125603" style="margin-right: 0.13rem">MEM-125603</el-radio>
                    <el-radio label="MEM-125604" style="margin-right: 0.13rem">MEM-125604</el-radio>
                    <el-radio label="Mlis" style="margin-right: 0.13rem">Mlis</el-radio>
                    <el-radio label="其他" style="margin-right: 0.13rem">其他</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div style="height: 0.06rem;"></div>
              <div class="content-table-2">
                <div class="content-table-21">报考年级：</div>
                <div class="content-table-22">
                  <el-radio-group v-model="idGrade" @change="changeSelect">
                    <el-radio :label="20" style="margin-right: 0.13rem">全部</el-radio>
                    <el-radio :label="2021" style="margin-right: 0.13rem">2021</el-radio>
                    <el-radio :label="2022" style="margin-right: 0.13rem">2022</el-radio>
                    <el-radio :label="2023" style="margin-right: 0.13rem">2023</el-radio>
                    <el-radio :label="2024" style="margin-right: 0.13rem">2024</el-radio>
                    <el-radio :label="2025" style="margin-right: 0.13rem">2025</el-radio>
                    <el-radio :label="2026" style="margin-right: 0.13rem">2026</el-radio>
                    <el-radio :label="2027" style="margin-right: 0.13rem">2027</el-radio>
                    <el-radio :label="2028" style="margin-right: 0.13rem">2028</el-radio>
                    <el-radio :label="2029" style="margin-right: 0.13rem">2029</el-radio>
                    <el-radio :label="100" style="margin-right: 0.13rem">其他</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="content-table-2">
                <div class="content-table-21">资讯分类：</div>
                <div class="content-table-22">
                  <el-radio-group v-model="idClassify" @change="changeSelect">
                    <el-radio label="全部" style="margin-right: 0.13rem">全部</el-radio>
                    <el-radio label="初试" style="margin-right: 0.13rem">初试</el-radio>
                    <el-radio label="复试" style="margin-right: 0.13rem">复试</el-radio>
                    <el-radio label="调剂" style="margin-right: 0.13rem">调剂</el-radio>
                    <el-radio label="会议" style="margin-right: 0.13rem">会议</el-radio>
                    <el-radio label="通知" style="margin-right: 0.13rem">通知</el-radio>
                    <el-radio label="活动" style="margin-right: 0.13rem">活动</el-radio>
                    <el-radio label="其他" style="margin-right: 0.13rem">其他</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <p style="font-size: 0.13rem">注：各招生单位的资讯由其自主维护，如有疑问，请咨询发布单位。</p>
          <div style="margin-bottom: 0.1rem;">
            <div v-for="item in fileData" :key="item.id" class="divcolor">
              <a :href="item.link" class="cell-link" target="_blank">
                <span class="cell-max">{{ item.filename }}</span>
                <span v-if="item.name !== ''" class="cell-name">（{{ item.name }}）</span>
              </a>
            </div>
          </div>
        </div>

        <div style="background-color: #edf4fc; padding-bottom: 0.2rem">
          <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>

      <div style="float: right;width: 28%;">
        <div style="width: 98%;padding: 1%;">
          <div class="news">最新初试内容</div>
          <div v-for="item in fileData1" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </div>

        <div style="width: 98%;padding: 1%;">
          <div class="news">最新复试内容</div>
          <div v-for="item in fileData2" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </div>

        <div style="width: 98%;padding: 1%;">
          <div class="news">最新调剂信息</div>
          <div v-for="item in fileData3" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </div>

      </div>
    </div>

    <hr>
    <div>
      <el-row>
        <el-col :span="8" style="padding: 0.15rem;">
          <div class="news">学校会议</div>
          <div v-for="item in fileData4" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </el-col>
        <el-col :span="8" style="padding: 0.15rem;">
          <div class="news">学校通知</div>
          <div v-for="item in fileData5" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </el-col>
        <el-col :span="8" style="padding: 0.15rem;">
          <div class="news">学校活动</div>
          <div v-for="item in fileData6" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank" style="width: 98%;">{{ item.filename }}</a>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
// 按需导入 API 接口
import { SelectInformationSchoolName, SelectInformationDataName, SelectInformation } from '@/api/informationAPI'

export default {
  name: 'Information',
  data() {
    return {
      dataName: '',
      schoolName: '',
      currentPage: 1,
      pageSize: 12,
      total: 1,
      fileData: [],
      fileData1: [],
      fileData2: [],
      fileData3: [],
      fileData4: [],
      fileData5: [],
      fileData6: [],
      activeName: 'first',
      idProvince: '全部',
      idMajor: '全部',
      idClassify: '全部',
      idGrade: 20,
      idButton: 0
    }
  },
  created() {
    this.contentFind()
    this.contentFind1()
    this.contentFind2()
    this.contentFind3()
    this.contentFind4()
    this.contentFind5()
    this.contentFind6()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async contentFind() {
      const { data: res } = await SelectInformation(this.idProvince, this.idMajor, this.idGrade, this.idClassify, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async contentFind1() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '初试', 1, 6)
      this.fileData1 = res.data[2]
    },
    async contentFind2() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '复试', 1, 6)
      this.fileData2 = res.data[2]
    },
    async contentFind3() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '调剂', 1, 6)
      this.fileData3 = res.data[2]
    },
    async contentFind4() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '会议', 1, 6)
      this.fileData4 = res.data[2]
    },
    async contentFind5() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '通知', 1, 6)
      this.fileData5 = res.data[2]
    },
    async contentFind6() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '活动', 1, 6)
      this.fileData6 = res.data[2]
    },
    async schoolFind() {
      const { data: res } = await SelectInformationSchoolName(this.schoolName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 2
    },
    async dataFind() {
      const { data: res } = await SelectInformationDataName(this.dataName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
    },
    async changeSelect() {
      this.currentPage = 1
      const { data: res } = await SelectInformation(this.idProvince, this.idMajor, this.idGrade, this.idClassify, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      document.documentElement.scrollTop = 380
      if (this.idButton === 1) {
        const { data: res } = await SelectInformationDataName(this.dataName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 2) {
        const { data: res } = await SelectInformationSchoolName(this.schoolName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 3) {
        const { data: res } = await SelectInformation(this.idProvince, this.idMajor, this.idGrade, this.idClassify, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 2rem;
  }
}
.content-table {
  margin: 0.1rem;
}
.content-table-1 {
  overflow: hidden;
  padding-top: 0.02rem;
}
.content-table-11 {
  float: left;
  width: 12%;
  font-size: 0.13rem;
}
.content-table-12 {
  float: left;
  width: 88%;
}
.content-table-2 {
  overflow: hidden;
}
.content-table-21 {
  float: left;
  width: 12%;
  font-size: 0.13rem;
  padding-top: 0.01rem;
}
.content-table-22 {
  float: left;
  padding-top: 0.05rem;
  width: 88%;
}
.content-body {
  overflow: hidden;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.05rem;
  font-size: 25px;
  font-weight: 700;
}
.divcolor {
  border: 1px dotted rgb(156, 156, 156);
  margin-bottom: 0.08rem;
  border-radius: 0.05rem;
}
.divcolor:hover {
  background-color: #ffb700;
}
.cell-link {
  display: inline-block;
  width: 9.3rem;
  font-size: 0.15rem;
  padding: 0.09rem 0 0.09rem 0.05rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cell-max {
  display: inline-block;
  max-width: 7.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 60%;
}
.cell-name {
  font-size: 0.13rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 30%;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio {
  margin-right: 0.07rem;
  margin-bottom: 0.05rem;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 0.13rem;
  color: #000;
}
/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: blue;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
